import { Application } from 'pixi.js';
import { GAME_WIDTH, GAME_HEIGHT } from '../constants';
import { SceneManager } from './SceneManager';
import { SceneType } from './SceneType';
import { LoadingScene } from '../scenes/LoadingScene';
import { PlayingScene } from '../scenes/PlayingScene';
import { InterstitialScene } from '../scenes/InterstitialScene';
import { EndGameScene } from '../scenes/EndGameScene';

export class Game {
  private app: Application;
  private sceneManager!: SceneManager;

  constructor() {
    this.app = new Application();
  }

  async init(): Promise<void> {
    await this.app.init({
      width: GAME_WIDTH,
      height: GAME_HEIGHT,
      backgroundColor: 0x1a1a2e,
      resolution: window.devicePixelRatio || 1,
      autoDensity: true,
    });

    const container = document.getElementById('game-container');
    if (container) {
      container.appendChild(this.app.canvas);
    }

    this.setupResizing();
    this.setupOrientation();

    this.sceneManager = new SceneManager(this.app.stage);
    this.registerScenes();

    this.app.stage.eventMode = 'static';
    this.app.stage.hitArea = this.app.screen;

    this.app.ticker.add((ticker) => {
      this.sceneManager.update(ticker.deltaMS / 1000);
    });

    this.sceneManager.go(SceneType.Loading);
  }

  private registerScenes(): void {
    this.sceneManager.register(SceneType.Loading, new LoadingScene(this.sceneManager));
    this.sceneManager.register(SceneType.Playing, new PlayingScene(this.sceneManager, this.app));
    this.sceneManager.register(SceneType.Interstitial, new InterstitialScene(this.sceneManager));
    this.sceneManager.register(SceneType.EndGame, new EndGameScene());
  }

  private setupResizing(): void {
    const resize = () => {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const scale = Math.min(
        windowWidth / GAME_WIDTH,
        windowHeight / GAME_HEIGHT
      );

      this.app.canvas.style.width = `${GAME_WIDTH * scale}px`;
      this.app.canvas.style.height = `${GAME_HEIGHT * scale}px`;
    };

    window.addEventListener('resize', resize);
    resize();
  }

  private setupOrientation(): void {
    const checkOrientation = () => {
      const isLandscape = window.innerWidth > window.innerHeight;
      if (!isLandscape) {
        console.warn('Please rotate your device to landscape mode for the best experience');
      }
    };

    window.addEventListener('orientationchange', checkOrientation);
    window.addEventListener('resize', checkOrientation);
    checkOrientation();
  }
}
